import React from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Input,
    Media,
    UncontrolledTooltip
} from 'reactstrap';
import {I18n} from '../../I18n/components/users';
import spinner from '../../assets/images/spinner.gif';

const UploadUserModal = props => {
    return (
        <Modal isOpen={props.uploadModal} toggle={props.toggle}>
            <ModalHeader toggle={props.toggle}>{I18n[props.lang].modal.uploadUserFile}</ModalHeader>
            <ModalBody>
                <Form onSubmit={props.sendFile}>
                    <FormGroup className="mb-1">
                        <div className="custom-file">
                            <Input
                                type="file"
                                className="custom-file-input"
                                id="upload_file"
                                onChange={props.onFileSelect}
                            />
                            <label className="custom-file-label" id="upload_apk_label" htmlFor="upload_apk">{props.uploadFileName}</label>
                        </div>
                    </FormGroup>
                    <FormGroup className="upload modal-buttons">
                        <Media
                            className={!props.isFileUpload ?
                                'modal-buttons__download visually-hidden' : 'modal-buttons__download'}
                            object
                            src={spinner}
                            alt="upload spinner"
                        />
                        <Button
                            color="primary"
                            type="submit"
                            className={props.isFileUpload ? 'invisible' : 'visible'}
                            disabled={!props.uploadFile}
                        >
                            {I18n[props.lang].modal.upload}
                        </Button>
                        <Button color="secondary" className="ml-1" onClick={props.toggle}>{I18n[props.lang].modal.cancel}</Button>
                        <div className="file-upload__helper">
                            <p>{I18n[props.lang].modal.fileFormat}
                                <span style={{textDecoration: "underline", color:"blue"}} href="#" id="UncontrolledTooltipExample">
											<i aria-hidden="true" className="mdi mdi-help-circle-outline"></i>
										</span>
                            </p>
                            <UncontrolledTooltip placement="right" target="UncontrolledTooltipExample">
                                <span className="csv-tooltip">{I18n[props.lang].modal.fileTooltipText}</span>
                            </UncontrolledTooltip>
                        </div>
                    </FormGroup>
                </Form>
            </ModalBody>
        </Modal>
    )
};

export default UploadUserModal;



// WEBPACK FOOTER //
// ./src/components/Users/UploadUserModal.js